module.exports = InternalShared('InternalShared/Events/FieldDragEnded');